export default __webpack_public_path__ + "static/media/sponsorship.6bce61dc.jpeg";